import { ArrowLeft } from "lucide-react";
import React from "react";


import {
  BodyText,
  Heading4,
} from "../../lib/ui/components/typography/Typography";
import Button from "../../lib/ui/components/button/Button";

export default function PageHeader({
  title,
  subtitle,
  description,
  onBack,
  actions,
  className = "",
  contentClassName = "",
}) {
  const renderTitle = () => {
    if (!title) return null;

    if (typeof title === "string") {
      return <Heading4>{title}</Heading4>;
    }

    return title;
  };

  return (
    <div className={`w-full bg-gray-100 ${className}`.trim()}>
      <div className="w-full border-t border-gray-300">
        <div
          className={`mx-auto flex justify-between items-center px-[24px] ${contentClassName}`.trim()}
        >
          <div className="flex items-center">
            <div
              className={`flex items-center my-6 gap-1 ${onBack ? "" : "-ml-4"}`.trim()}
            >
              <Button
                onClick={onBack}
                variant="tertiary"
                className="!px-2"
                aria-label="Go back"
                disabled={!onBack}
              >
                {onBack ? <ArrowLeft size="1em" /> : <span className="w-4 h-4" />}
              </Button>
              {(title || subtitle || description) && (
                <div>
                  {renderTitle()}
                  {subtitle && (
                    <BodyText className="text-gray-600 mt-1">
                      {subtitle}
                    </BodyText>
                  )}
                  {description && (
                    <BodyText className="text-gray-500 mt-1">
                      {description}
                    </BodyText>
                  )}
                </div>
              )}
            </div>
          </div>
          {actions ? (
            <div className="flex gap-[16px] items-center mr-6">{actions}</div>
          ) : (
            <div className="mr-6" />
          )}
        </div>
      </div>
    </div>
  );
}

